import useTranslation from 'next-translate/useTranslation'
import React, { useContext, useEffect } from 'react'
import { useRouter } from 'next/router'

import { UserContext } from './user-info-provider/user-context'
import { DEFAULT_LISTING_PAGE } from '../../listings/utils/routing/constants'
import { NoOp } from '@unreserved-frontend-v2/utils/noop'
import { Button } from '@unreserved-frontend-v2/ui/button/button'
import { Modal } from '@unreserved-frontend-v2/ui/modal/modal'

interface Props {
  isSSR?: boolean
}

export function CREATermsModal({ isSSR }: Props) {
  const { t } = useTranslation()
  const { push } = useRouter()
  const { updateCREATermsAccepted } = useContext(UserContext)

  const onBack = () => {
    // Direct visits will always go back to default listing, same as the back button in details subheader
    if (isSSR) {
      push(DEFAULT_LISTING_PAGE)
    } else {
      window.history.back()
    }
  }

  useEffect(() => {
    document.querySelector('#__next')?.classList.toggle('isCREABlocked', true)

    return () => {
      document.querySelector('#__next')?.classList.toggle('isCREABlocked', false)
    }
  }, [])

  return (
    <Modal
      isOpen={true}
      onClose={NoOp}
      isClosable={false}
      contentSx={{
        padding: '0',
        textAlign: 'start',
        display: 'flex',
        flexDirection: 'column',
      }}
      title={t('users:crea-terms-modal.title')}
      iconSx={{ right: '7px', top: '6px' }}
    >
      <div className="flex flex-1 flex-col gap-1 overflow-auto px-[31px] pb-6 text-base">
        <br />
        {new Array(4).fill(null).map((_, indx) => {
          const title = t(`users:crea-terms-modal.section-${indx + 1}-title`)
          const content = t(`users:crea-terms-modal.section-${indx + 1}-content`)
          if (!title) {
            return null
          }
          return (
            <React.Fragment key={title}>
              <div className="font-bold">{title}</div>
              <div className="text-base leading-[26px]" dangerouslySetInnerHTML={{ __html: content }} />
              <br />
            </React.Fragment>
          )
        })}
      </div>
      <div className="border-shades-200 flex justify-between border-t py-[16px] px-[31px]">
        <Button className="flex h-8 items-center py-0" variant="ghost" onClick={onBack}>
          {t('users:go-back')}
        </Button>
        <Button
          data-testid="accept-terms"
          className="flex h-8 items-center py-0"
          onClick={() => {
            updateCREATermsAccepted(true)
          }}
        >
          {t('users:crea-terms-modal.accept-terms')}
        </Button>
      </div>
    </Modal>
  )
}

export default CREATermsModal
